import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { TranslocoLoader, Translation } from "@jsverse/transloco";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class TranslocoLoaderService implements TranslocoLoader {
  public _http = inject(HttpClient);

  getTranslation(lang: string): Observable<Translation> {
    return this._http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}
